import React from 'react';
import Grid from '@nubank/nuds-web/components/Grid/Grid';
import Collapse from '@nubank/nuds-web/components/Collapse/Collapse';
import Box from '@nubank/nuds-web/components/Box/Box';
import Link from '@nubank/nuds-web/components/Link/Link';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import StyledCollapse from '../styles/StyledCollapse';

function PrivacyPolicyLinks() {
  return (
    <Grid.Child>
      <StyledCollapse id="privacy" initiallyOpen>
        <Collapse.Header>
          <Typography
            color="white.default"
            variant="subtitle1"
            strong
          >
            Política de Privacidad
          </Typography>
        </Collapse.Header>

        <Collapse.Body>
          <Box
            display="flex"
            flexDirection="column"
            marginTop="4x"
          >
            <Link
              color="white"
              typographyProps={{ variant: 'paragraph1', strong: true, marginBottom: '2x' }}
              href="/aviso-de-privacidad-clientes-y-prospectos"
            >
              Si eres prospecto o cliente
            </Link>
            <Link
              color="white"
              typographyProps={{ variant: 'paragraph1', strong: true, marginBottom: '2x' }}
              href="/aviso-de-privacidad-candidatos"
            >
              Si te postulas a una vacante
            </Link>
            <Link
              color="white"
              typographyProps={{ variant: 'paragraph1', strong: true, marginBottom: '2x' }}
              href="/aviso-de-privacidad-proveedores"
            >
              Si provees un servicio
            </Link>
            <Link
              color="white"
              typographyProps={{ variant: 'paragraph1', strong: true, marginBottom: '2x' }}
              href="/aviso-de-privacidad-redes-sociales"
            >
              Privacidad en redes sociales
            </Link>
            <Link
              color="white"
              typographyProps={{ variant: 'paragraph1', strong: true, marginBottom: '2x' }}
              href="/aviso-de-privacidad-asistencia"
            >
              Si hay mal uso de tu identidad
            </Link>
            <Link
              color="white"
              typographyProps={{ variant: 'paragraph1', strong: true, marginBottom: '8x' }}
              href="/aviso-de-privacidad-beneficiarios"
            >
              Beneficiarios
            </Link>
          </Box>
        </Collapse.Body>
      </StyledCollapse>
    </Grid.Child>
  );
}

export default PrivacyPolicyLinks;
